// Shared Admin (user management) constants + helpers.

// New accounts are Staff or Maintenance only; Management is not created here.
export const ADMIN_CREATE_ROLES = ["staff", "maintenance"] as const;

const ROLE_LABELS: Record<string, string> = {
  management: "Management",
  staff: "Staff",
  maintenance: "Maintenance",
};

export function roleLabel(r: string): string {
  return ROLE_LABELS[r] ?? r;
}
